// extracted by mini-css-extract-plugin
module.exports = {"distance":"DealerLocatorSearchResultDistance_distance__hFxGh"};